import { Stage } from 'konva/lib/Stage';
import { useCallback, useEffect, useState } from 'react';
import { HallmapProps } from '../types';
import { useCanvasGame } from './useCanvasGame';

export const useCanvasHallmap = ({
	setHallmap,
	id = 'hallmap',
	containerId = 'hallmap-container',
	mode = 'static',
	order,
}: HallmapProps) => {
	const [stage, setStage] = useState<Stage | null>(null);
	const [mapInit, setMapInit] = useState(false);

	const getHallmapContainer = useCallback(() => {
		return document.getElementById(containerId);
	}, [containerId]);

	useCanvasGame({
		setHallmap,
		stage,
		mode,
		order,
	});

	const createStage = useCallback(() => {
		const hallmapContainer = getHallmapContainer();
		return new Stage({
			container: id,
			width: hallmapContainer
				? hallmapContainer.offsetWidth
				: window.innerWidth,
			height: hallmapContainer
				? hallmapContainer.offsetHeight
				: window.innerHeight,
			draggable: true,
		});
	}, [getHallmapContainer, id]);

	const updateLayout = useCallback(
		(stage: Stage) => () => {
			const hallmapContainer = getHallmapContainer();

			let width = window.innerWidth;
			if (hallmapContainer) {
				width = hallmapContainer.offsetWidth;
			}

			stage.width(width);
			stage.height(
				hallmapContainer
					? hallmapContainer.offsetHeight
					: window.innerHeight,
			);
			stage.batchDraw();
		},
		[getHallmapContainer],
	);

	const setUpdateCanvasHallmapEvents = useCallback(() => {
		const stage = createStage();

		window.addEventListener('orientationchange', () => {
			setTimeout(updateLayout, 150);
		});

		window.addEventListener('resize', updateLayout(stage));

		setStage(stage);

		return () => {
			stage.destroy();
			window.removeEventListener('resize', updateLayout(stage));
			window.removeEventListener(
				'orientationchange',
				updateLayout(stage),
			);
		};
	}, [createStage, updateLayout]);

	useEffect(() => {
		if (mapInit) {
			return setUpdateCanvasHallmapEvents();
		}

		setMapInit(true);
	}, [setUpdateCanvasHallmapEvents, mapInit]);
};
